import type { ShopProducts } from './types'
import type { Product } from 'types'

import createReducer from '../createReducer'
import { Action, Nullable } from '../model'
import { ActionType } from './types'







export interface ShopReducer {
  products: Nullable<ShopProducts>
  product: Nullable<Product>
}

const defaultState: ShopReducer = {
  products: null,
  product: null,
}

export const shopReducer = createReducer<ShopReducer>(defaultState, {
  [ActionType.SET_SHOP_PRODUCTS]: (state: Nullable<ShopReducer>, action: Action<ShopProducts>) => ({
    ...state,
    products: action.payload,
  }),

  [ActionType.SET_SINGLE_SHOP_PRODUCT]: (state: Nullable<ShopReducer>, action: Action<Nullable<Product>>) => ({
    ...state,
    product: action.payload,
  }),

})
